import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.7_patch_hash=c6f354dff9a1b37e0e83493471843b5381f29a5a6b3b3e7486ab1a8be4de2ac4_ec29dcd8f4a7956f686a83b6f6500340/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/build/repo/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}